import React, { useState } from "react";
import "./RewardsTickHomePage.scss"
import grp from "../image/grp.jpg"
import InputComponent from "../components/InputComponent/InputComponent";
import Button from "../components/Button/Button";
import HeaderText from "../components/Text/HeaderText";
import SubheaderText from "../components/Text/SubheaderText";
import { contactEnquiry } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
const RewardsTickSubscribePage = () => {
    const companyDetails = useSelector((state) => state.companyData.company)
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [errors, setErrors] = useState({
        firstName: "",
        email: "",
        lastName: ""
    })

    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;

        const newErrors = {
            firstName: "",
            email: "",
            lastName: ""
        };

        const trimmedFirstName = firstName.trim();
        const trimmedLastName = lastName.trim();
        const trimmedEmail = email.trim();
        if (trimmedFirstName === "") {
            newErrors.firstName = "*Required";
            valid = false;
        } else if (trimmedFirstName.length < 2 || !nameRegex.test(trimmedFirstName)) {
            newErrors.firstName = "Please enter a valid name";
            valid = false;
        }
        if (trimmedLastName === "") {
            newErrors.lastName = "*Required";
            valid = false;
        } else if (trimmedLastName.length < 2 || !nameRegex.test(trimmedLastName)) {
            newErrors.lastName = "Please enter a valid name";
            valid = false;
        }
        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.ID || "",
            "Name": firstName + " " + lastName,
            "Email": email,
            "PhoneNo": "",
            "Message": "",
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFirstName("")
                setLastName("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    return (
        <div className="RewardsTickSubscribePage">
            <div className="RewardsTickSubscribePage-inner">
                <div className="RewardsTickSubscribePage-inner-left">
                    <HeaderText
                        text={"Stay in the Loop!"} />
                    <div className="RewardsTickSubscribePage-subheader">
                        <SubheaderText
                            text={"Be the first to know about new features, exclusive deals, and special promotions. Join our newsletter community."}
                        />
                    </div>
                    <div className="RewardsTickSubscribePage-form">
                        <div className="RewardsTickSubscribePage-form-flex">
                            <InputComponent
                                placeholder={"First Name"}
                                onChange={(e) => {
                                    setFirstName(e.target.value)
                                    handleChange("firstName")
                                }}
                                value={firstName}
                                required
                                error={errors.firstName !== ""}
                                errorText={errors.firstName}
                            />
                            <InputComponent
                                placeholder={"Last Name"}
                                onChange={(e) => {
                                    setLastName(e.target.value)
                                    handleChange("lastName")

                                }}
                                value={lastName}
                                required
                                error={errors.lastName !== ""}
                                errorText={errors.lastName} />
                        </div>
                        <InputComponent
                            placeholder={"Email"}
                            onChange={(e) => {
                                setEmail(e.target.value)
                                handleChange("email")

                            }}
                            value={email}
                            required
                            error={errors.email !== ""}
                            errorText={errors.email}
                        />
                        {showSuccess && < div className="succes-alert">
                            ✔ Thank you for subscribing. You're all set to enjoy our latest updates and features.
                        </div>}
                        <Button
                            buttonText={"Subscribe Now"}
                            isloading={loading} onClick={handleContact} />
                    </div>

                </div>
                <div className="RewardsTickSubscribePage-inner-right">
                    <img alt="" src={grp} />
                </div>
            </div>
        </div>
    )
}
export default RewardsTickSubscribePage